<article class="alert" role="alert" [ngClass]="status">
  <div class="alert__inner">
    @if (title) {
      <header class="alert__header">
        @if ((alertIcon && showIcon) || icon) {
          <app-icon class="" [anchor]="(alertIcon || icon)!"></app-icon>
        }
        <h2 class="h6 alert__title mb-0">{{ title }}</h2>
      </header>
    }
    <div class="alert__content markdown-content">
      @if (message) {
        <p class="type-body-sm fw-normal">
          {{ message }}
        </p>
      }

      <!-- Shopify error list -->
      @if (errors.length > 1) {
        <ul class="error-list mb-1">
          @for (error of errors; track error.code) {
            <li class="error-list__item">
              @if (!useErrormessagesFromShopify) {
                <p class="type-body-sm fw-normal">
                  {{ (shopifyCodePrefix + '-' + error?.code | fromDictionary: !useFallbackErrormessagesFromShopify) || error?.message }}
                </p>
              }
              @if (useErrormessagesFromShopify) {
                <p class="type-body-sm fw-normal">
                  {{ error?.message }}
                </p>
              }
            </li>
          }
        </ul>
      }

      <!-- Shopify single error -->
      @if (errors.length === 1) {
        <p class="type-body-sm fw-normal">
          @if (!useErrormessagesFromShopify) {
            {{ (shopifyCodePrefix + '-' + errors[0].code | fromDictionary: !useFallbackErrormessagesFromShopify) || errors[0].message }}
          }
          @if (useErrormessagesFromShopify) {
            {{ errors[0].message }}
          }
        </p>
      }

      <!-- Shopify error unknown  -->
      @if (!errors.length && showDefaultError) {
        <p class="type-body-sm fw-normal">{{ prefix + '-foutcode-onbekend' | fromDictionary }}</p>
      }

      <ng-content></ng-content>
    </div>
  </div>
</article>
